import { render } from "./AdminChart.vue?vue&type=template&id=304e2641&scoped=true"
import script from "./AdminChart.vue?vue&type=script&lang=js"
export * from "./AdminChart.vue?vue&type=script&lang=js"

import "./AdminChart.vue?vue&type=style&index=0&id=304e2641&scoped=true&lang=css"

import exportComponent from "/home/runner/work/prayerwall/prayerwall/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-304e2641"]])

export default __exports__